import {ErrorHandler, Injectable} from "@angular/core";

// App-wide safety net for anything that escapes a component/service (uncaught promise rejections,
// async-pipe stream errors, lifecycle throws, …). Logs every error and makes a best-effort guess
// at the originating component/widget from the stack trace, so an otherwise anonymous error still
// points somewhere useful. For a guaranteed widget label, pipe the widget's stream through
// `catchWidgetError(...)` as well.
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const stack = String(error?.stack ?? error?.message ?? error ?? "");
    // First Angular component / widget class name mentioned in the stack, if any.
    const match = stack.match(/\b(Ehr[A-Za-z0-9]*Component|[A-Za-z0-9]+WidgetComponent)\b/);
    const where = match ? ` (likely in ${match[1]})` : "";
    console.error(`[app error]${where}:`, error);
  }
}
